import React, { useEffect } from 'react';
import { IconLock } from '@tabler/icons-react';
import PasswordContent from '../components/settingsContents/PasswordContent';
import './Settings.css';

// Navigation items configuration
const NAV_ITEMS = [
    { id: 'passwort', label: 'Passwort', icon: IconLock },
];

const Settings = () => {
    useEffect(() => {
        document.title = 'TRAC - Einstellungen';
    }, []);

    return (
        <div className="settings-page flex-grow-1">
            {/* Header */}
            <div className="settings-header">
                <h1 className="settings-title">Einstellungen</h1>
                <p className="settings-subtext">
                    Verwalte Deine Kontoeinstellungen und Präferenzen.
                </p>
            </div>

            <hr />

            {/* Main content area */}
            <div className="settings-content">
                {/* Navigation sidebar */}
                <nav className="settings-nav">
                    <ul className="settings-nav-list">
                        {NAV_ITEMS.map((item) => {
                            const IconComponent = item.icon;
                            return (
                                <li key={item.id}>
                                    <button className="settings-nav-item active">
                                        <IconComponent size={20} stroke={1.5} className="nav-icon" />
                                        {item.label}
                                    </button>
                                </li>
                            );
                        })}
                    </ul>
                </nav>

                {/* Content area */}
                <main className="settings-main">
                    <div className="settings-card">
                        <PasswordContent />
                    </div>
                </main>
            </div>
        </div>
    );
};

export default Settings;